import React, { useState } from "react";
import { Box, Typography, CircularProgress } from "@material-ui/core";
import Zoom from "@material-ui/core/Zoom";
import { CancelButton, OkButton } from "../../../../../styles/button/styles";
import { CustomModal } from "../../../../../styles/modal/styles";
import { ModalContent } from "../../../../../styles/box/styles";

const SaveNewItemsConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  resources,
  message,
  loading,
}) => {
  const [disabled, setDisabled] = useState(false);

  const confirmSave = async () => {
    setDisabled(true);
    await onConfirm();
    setDisabled(false);
  };

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      BackdropProps={{ style: { backgroundColor: "#0000004D" } }}
    >
      <Zoom in={open} timeout={350}>
        <ModalContent style={{ transform: open ? "scale(1)" : "scale(0.3)" }}>
          <Box mt={2.5} padding={2.5} minHeight={118} alignContent="center">
            {loading ? (
              <Box className="centered-loader fadeIn">
                <CircularProgress />
              </Box>
            ) : (
              <Typography align="center">{message}</Typography>
            )}
          </Box>
          {!loading && (
            <Box display="flex" justifyContent="flex-end" padding={1.5}>
              <CancelButton id="btnCancelSave" onClick={onClose}>
                {resources["Cancel"]}
              </CancelButton>
              <OkButton id="btnSave" onClick={confirmSave} disabled={disabled}>
                {resources["Yes"]}
              </OkButton>
            </Box>
          )}
          <span className="rodal-close" onClick={onClose}></span>
        </ModalContent>
      </Zoom>
    </CustomModal>
  );
};

export default SaveNewItemsConfirmationModal;
